import colors from 'assets/styles/jsVariables/colors';

export default {
  modal: {
    zIndex: 10001
  },
  title: {
  },
  subTitle: {
    fontFamily: 'proxima_novaregular',
    color: colors.darkGrey,
    fontSize: '18px'
  },
  titleContainer: {
    marginRight: '0px',
    fontFamily: 'proxima_novaregular',
    color: colors.darkGrey,
    fontSize: '22px',
    paddingLeft: '42px',
    paddingRight: '48px'
  },
  xIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: 48,
    width: 48,
    padding: 0
  },
  iconContainer: {
    width: 16,
    height: 16,
  },
  bodyStyle: {
    paddingLeft: 42,
    paddingRight: 26,
    marginRight: 16,
  },
  paperStyle: {
    backgroundColor: 'rgb(255, 255, 255)',
  },
  overlayStyle: {
    backgroundColor: 'rgba(43,43,43,0.75)',
    opacity: 0.58
  },
  iframeXIcon: {
    position: 'absolute',
    top: -3,
    right: 5
  },
  iframeIconContainer: {
    width: 14,
    height: 14
  }
};




// WEBPACK FOOTER //
// ./src/components/Modal/styles.js